var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',_vm._b({attrs:{"placeholder":_vm.$t('search'),"classes":'gst-btn--search'},on:{"click":function($event){return _vm.$emit('click')}}},'BaseButton',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }